import { Stack } from "@mui/material";
import CollectionFiltersDetail from "../pages/filters/CollectionFiltersDetail";
import CollectionDetailTable from "../tables/CollectionDetailTable";

function Collections() {

    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <CollectionFiltersDetail/>
                <CollectionDetailTable/>
            </Stack>
    );
}

export default Collections;